export default __webpack_public_path__ + "static/media/main-app-white-(orig).954b48a3.png";